import React, { useContext } from 'react';
import {
	IFirmwareAssignmentContext,
	FirmwareAssignmentContext,
} from '../../../../firmwareAssignmentState/firmwareAssignmentContext';
import SearchField from 'components/SearchField/SearchField';
import classNames from 'classnames';
import style from './SearchFields.module.scss';

const SearchFields: React.FC = () => {
	const {
		changeSearchStringForAllCustomers,
		changeSearchStringForRestaurants,
		changeSearchStringForFirmwares,
		searchStringForAllCustomers,
		searchStringForRestaurants,
		searchStringForFirmwares,
		activeItemToDisplay,
	} = useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);

	const customerSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'customers',
	});
	const restaurantSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'restaurants',
	});
	const firmwareSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'firmware',
	});

	return (
		<div className={style.container}>
			<div className={customerSearchFieldWrapperClasses}>
				<SearchField
					onChangeSelectSearchString={changeSearchStringForAllCustomers}
					searchString={searchStringForAllCustomers}
				/>
			</div>
			<div className={restaurantSearchFieldWrapperClasses}>
				<SearchField
					onChangeSelectSearchString={changeSearchStringForRestaurants}
					searchString={searchStringForRestaurants}
				/>
			</div>
			<div className={firmwareSearchFieldWrapperClasses}>
				<SearchField
					onChangeSelectSearchString={changeSearchStringForFirmwares}
					searchString={searchStringForFirmwares}
				/>
			</div>
		</div>
	);
};

export default SearchFields;
